const template = `
	<sup
		v-if="val"
		class="val-diff"
		:class="val > 0 ? 'val-green' : 'val-red'"
	>
		<template v-if="val > 0">
			<i class="zmdi zmdi-long-arrow-up"></i>{{ val }}
		</template>
		<template v-else>
			<i class="zmdi zmdi-long-arrow-down"></i>{{ -val }}
		</template>
	</sup>
`;

export default {
	template,
	props: ['val']
};